import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceBold',
  standalone: false,
})
export class ReplaceBoldPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text) {
      return text as any;
    }

    // Replace **text** with <span class="font-weight-500">text</span>
    // The regex matches ** followed by any characters (non-greedy) followed by **
    const html = text.replace(
      /\*\*(.+?)\*\*/g,
      '<span class="font-weight-500">$1</span>',
    );
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
